<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .recent-refreshes {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: utils.in_rem(10px);
    overflow: auto;

    h3 {
      @include mixins.h3();
      margin: 0;
    }
  }

  .table-wrapper {
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: utils.in_rem(10px);
    padding: utils.in_rem(6px);
    background: #fff;
    overflow: auto;
  }

  .table-scroll-container {
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    border-top: none;
    position: relative;
  }

  .table-scroll {
    overflow-y: auto;
    height: 100%;
    min-height: 0;
  }

  .table-header {
    background-color: colors.get(interfaceSwGrey_5);
  }

  .empty-state {
    text-align: center;
    padding: 2rem;
    background-color: colors.get(interfaceSwGrey_5);
    border-radius: 4px;
    color: colors.get(interfaceSwGrey_20);
  }
</style>

<script>
  import { integrationStore } from "../../../stores";

  import Table from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/Table.svelte";
  import TBODY from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TBODY.svelte";
  import TD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TD.svelte";
  import THEAD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/THEAD.svelte";
  import TR from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TR.svelte";

  export let recentRefreshes = [];

  $: providerTitle = $integrationStore.getProviderTitle();
  $: hasData = recentRefreshes && recentRefreshes.length > 0;

  const headers = [
    "CONTACT NAME",
    "JOB TITLE",
    "COMPANY",
    "CONTACT TYPE",
    "REFRESHED",
  ];
</script>

<div class="recent-refreshes">
  <h3>Recently Refreshed {providerTitle} Contacts</h3>

  {#if hasData}
    <div class="table-wrapper">
      <div class="table-scroll-container">
        <div class="table-scroll">
          <Table>
            <colgroup>
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
            </colgroup>
            <THEAD>
              <TR class="table-header">
                {#each headers as header}
                  <TD header>{header}</TD>
                {/each}
              </TR>
            </THEAD>
            <TBODY>
              {#each recentRefreshes as refresh}
                <TR>
                  <TD>{refresh.name || "-"}</TD>
                  <TD>{refresh.title || "-"}</TD>
                  <TD>{refresh.company || "-"}</TD>
                  <TD>{refresh.type || "-"}</TD>
                  <TD>{refresh.refreshed || "-"}</TD>
                </TR>
              {/each}
            </TBODY>
          </Table>
        </div>
      </div>
    </div>
  {:else}
    <div class="empty-state">
      <p>No recently refreshed contacts</p>
    </div>
  {/if}
</div>
